import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "container-wide w-100 flex-shrink-1 flex-grow-1 d-flex flex-column",
  style: {"min-height":"0"}
}
const _hoisted_2 = { class: "card p-5 mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "Version 1.0 (30.6.2023)", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Erster Release im Rahmen des Projektes")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_translate = _resolveComponent("translate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, [
        _createVNode(_component_translate, null, {
          default: _withCtx(() => [
            _createTextVNode("Versionshinweise der Software")
          ]),
          _: 1
        })
      ]),
      _hoisted_3,
      _hoisted_4
    ])
  ]))
}